const { useTranslation } = require("react-i18next");

const useGetTranslationLanguage = () => {
	const { t } = useTranslation();
	const translationLanguage = lang =>
		t("LANGUAGE." + lang, {
			defaultValue: lang
		});
	return translationLanguage;
};
export default useGetTranslationLanguage;
